module.exports = __webpack_public_path__ + "./images/loyalCard.d2b725e8cbc36d12e087b823a452f670.png";